export const WEBVIEW83_COMPATIBILITY_MARKER = "__VARNAX_WEBVIEW83_AT_COMPATIBILITY__";

type IndexedValue = { readonly length: number; readonly [index: number]: unknown };

export function legacyAt(this: IndexedValue, index: number): unknown {
  const length = Math.max(0, Math.min(Number.MAX_SAFE_INTEGER, Math.trunc(Number(this.length)) || 0));
  const numericIndex = Number(index);
  const relativeIndex = Number.isNaN(numericIndex) ? 0 : Math.trunc(numericIndex);
  const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
  return actualIndex < 0 || actualIndex >= length ? undefined : this[actualIndex];
}

const defaultAtPrototypes: readonly object[] = [
  Array.prototype, String.prototype,
  Int8Array.prototype, Uint8Array.prototype, Uint8ClampedArray.prototype,
  Int16Array.prototype, Uint16Array.prototype, Int32Array.prototype, Uint32Array.prototype,
  Float32Array.prototype, Float64Array.prototype, BigInt64Array.prototype, BigUint64Array.prototype,
];

export function installWebView83AtCompatibility(targets: readonly object[] = defaultAtPrototypes): void {
  for (const target of targets) {
    if (typeof (target as { at?: unknown }).at === "function") continue;
    Object.defineProperty(target, "at", { value: legacyAt, writable: true, enumerable: false, configurable: true });
  }
  Object.defineProperty(globalThis, WEBVIEW83_COMPATIBILITY_MARKER, { value: true, writable: false, enumerable: false, configurable: false });
}

installWebView83AtCompatibility();
